import forEach from 'lodash/forEach';
import decode from 'unescape';

export default function separateMessageText(answer, partialId) {
  const decodedAnswer = decode(answer);

  const parser = new DOMParser();
  const parsedHtml = parser.parseFromString(decodedAnswer, 'text/html');
  const elements = parsedHtml.body.querySelectorAll(`[id^="${partialId}"]`);

  const multipleAnswer = [];

  forEach(elements, item => {
    const isEmptyInnerText =
      typeof item.innerText === 'string' ? item.innerText.trim() === '' : false;
    const isEmptyInnerHTML = item.innerHTML.trim() === '&nbsp;';
    const isCarousel = item.dataset.name === 'carousel' || '';
    const isOuterHtml = Boolean(item.outerHTML);
    const isEmptyAnswer = isEmptyInnerText && isEmptyInnerHTML && isOuterHtml;

    if (!isEmptyAnswer && !isCarousel) {
      multipleAnswer.push(item.outerHTML);
    }
    if (isCarousel) {
      const { position } = item.dataset;
      multipleAnswer.splice(position, 0, item.outerHTML);
    }
    return multipleAnswer;
  });

  return multipleAnswer;
}
